// React
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import SimpleBar from 'simplebar-react';
import classNames from 'classnames';
// Material UI Components
import Paper from '@mui/material/Paper';
import SortByAlphaIcon from '@mui/icons-material/SortByAlpha';
import SortIcon from '@mui/icons-material/Sort';
import IconButton from '@mui/material/IconButton';
import InfoIcon from '@mui/icons-material/Info';
import IconRefresh from '@mui/icons-material/Cached';
// PCP Components
import DialogInfo from 'components/dialog/DialogInfo/DialogInfo';
import DoubleCategoryBar from 'components/filter/pricingEngine/DoubleCategoryBar/DoubleCategoryBar';
// Util
import { calcColorAndSize, getHigherCardinality, sortCategories } from 'components/filter/pricingEngine/CategoryFilter/CategoryFilter.util';
// Styles
import { useStyles } from 'components/filter/pricingEngine/CategoryFilter/CategoryFilter.style';
// Theme
import { useTheme } from '@mui/styles';
// Locales
import translate from 'locales/i18n';
// Images
import CatagoryFilterExample from 'assets/img/pricing-engine-examples/pricing-engine-category-filter.png';

const CategoryFilter = ({ categories, categoriesVisible, isLoading, reset, selectCategory }) => {
    const [dialogInfoOpen, setDialogInfoOpen] = useState(false);
    const classes = useStyles();
    const [state, setState] = useState({
        alpha: true,
        percent: true,
        sort: true,
        value: 1
    });
    const theme = useTheme();

    const { alpha, percent, sort, value } = state;

    const higherCardinality = getHigherCardinality(categories);

    const handleChange = (v) => {
        if (v === 0)
            setState({
                alpha: !alpha,
                percent,
                sort,
                value: v
            });

        if (v === 1)
            setState({
                alpha,
                percent,
                sort: !sort,
                value: v
            });

        if (v === 2)
            setState({
                alpha,
                percent: !percent,
                sort,
                value: v
            });
    };

    const renderDialogInfo = () => <DialogInfo open={dialogInfoOpen}
        close={() => setDialogInfoOpen(false)}>
        <div className={classes.infoMainText}>{translate.i18n('CATEGORY_FILTER_EXPLANATION_PRICING_ENGINE_1')}</div>
        <ul>
            <li className={classes.infoSubText}>{translate.i18n('CATEGORY_FILTER_EXPLANATION_2')}</li>
            <li className={classes.infoSubText}>{translate.i18n('CATEGORY_FILTER_EXPLANATION_PRICING_ENGINE_3')}</li>
        </ul>
        <div className={classes.infoImgContainer}><img src={CatagoryFilterExample} /></div>
        <div className={classes.infoLegendText}>{translate.i18n('CATEGORY_FILTER_EXPLANATION_4')}</div>
    </DialogInfo>;

    return (
        <Paper className={classNames(classes.paper, isLoading && classes.notAllowed)}>
            <div className={classes.title}>
                <div>
                    <IconButton onClick={() => handleChange(0)} color={state.value === 0 ? 'primary' : 'grey'}>
                        <SortByAlphaIcon />
                    </IconButton>
                    <IconButton onClick={() => handleChange(1)} color={state.value === 1 ? 'primary' : 'grey'}>
                        <SortIcon />
                    </IconButton>
                    <IconButton onClick={() => handleChange(2)} color={state.value === 2 ? 'primary' : 'grey'}>
                        <mat-icon inline='true' matSuffix>%</mat-icon>
                    </IconButton>
                </div>
                {translate.i18n('CATEGORIES')}
                <div>
                    <IconButton
                        color='primary'
                        onClick={reset}>
                        <IconRefresh />
                    </IconButton>
                    <IconButton
                        color='primary'
                        onClick={() => setDialogInfoOpen(true)}>
                        <InfoIcon />
                    </IconButton>
                </div>
            </div>
            <div className={classes.categoryListContainer}>
                <SimpleBar className={classes.simpleBar}>
                    {sortCategories(calcColorAndSize(categories.slice(0), theme), alpha, sort, percent, value).map((category, key) =>
                        <DoubleCategoryBar category={category}
                            higherCardinality={higherCardinality}
                            categoriesVisible={categoriesVisible}
                            isLoading={isLoading}
                            selectCategory={selectCategory}
                            key={key} />
                    )}
                </SimpleBar>
            </div>
            {categories.length > 0 && <div className={classes.bottomContainer}>
                <div>Actuellement</div>
                <div>Après repricing</div>
            </div>}
            {renderDialogInfo()}
        </Paper>
    );
};

CategoryFilter.propTypes = {
    categories: PropTypes.array,
    categoriesVisible: PropTypes.array,
    isLoading: PropTypes.bool,
    reset: PropTypes.func,
    selectCategory: PropTypes.func
};

export default CategoryFilter;
